import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Budget',
  icon: 'mdi-cash-multiple',
  path: '/reports/controls/',
  ...addPermissionsToRoute(['mtBudget']),
  children: [
    {
      path: '/reports/controls/fiscalBudget',
      name: 'Fiscal Budget',
      component: () => import('./FiscalBudget.vue'),
      meta: {
        id: 'reports-mtFiscalBudget',
      },
    },
  ],
};

export default routes;
